var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('div',[_c('result-card',{staticClass:"grid grid-cols-2 gap-8",attrs:{"doctorSearchRecords":_vm.doctorSearchRecords}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }